module.exports = __webpack_public_path__ + "img/share.417c4991.svg";